import VehiclesAndAssets from '../pages/fleetEquipment/VehiclesAndAssets'
import AssetManager from '../pages/fleetEquipment/AssetManager'
import VDIsAndSafetyChecks from '../pages/fleetEquipment/VDIsAndSafetyChecks'
import Defects from '../pages/fleetEquipment/Defects'
import CleaningSchedules from '../pages/fleetEquipment/CleaningSchedules'
import MakeReadyAndMaintenance from '../pages/fleetEquipment/MakeReadyAndMaintenance'
import LoadLists from '../pages/fleetEquipment/LoadLists'

export default [
  {
    id: 'vehicles-and-assets',
    title: 'Vehicles and Assets',
    pages: [
      {
        id: 'vehicles-and-assets',
        title: 'Vehicles',
        summary:
          'The vehicle list and availability view, adding vehicles, the vehicle record (hero and tabs), servicing/MOT/insurance, fuel logs and fuel cards, LOLER inspections, planned downtime, and archiving.',
        component: VehiclesAndAssets,
        tags: [
          'Vehicles',
          'Availability',
          'DVLA',
          'MOT',
          'Servicing',
          'Insurance',
          'Fuel',
          'Fuel Cards',
          'LOLER',
          'Planned Downtime',
          'Archive',
        ],
      },
      {
        id: 'asset-manager',
        title: 'Asset Manager',
        summary:
          'Register and browse equipment, the asset record (hero and tabs), parent assets and check-out, vehicle assignment, planned downtime, QR-code labels, and maintenance logs.',
        component: AssetManager,
        tags: [
          'Assets',
          'Asset Manager',
          'QR Code',
          'Maintenance',
          'Equipment',
          'Check Out',
          'Parent Asset',
          'Planned Downtime',
        ],
      },
    ],
  },
  {
    id: 'checks-and-defects',
    title: 'Checks and Defects',
    pages: [
      {
        id: 'vdis-and-safety-checks',
        title: 'VDIs and Safety Checks',
        summary:
          'Record vehicle daily inspections, review completed VDIs, and record, amend, and delete formal vehicle safety checks.',
        component: VDIsAndSafetyChecks,
        tags: ['VDI', 'Safety Check', 'Daily Inspection', 'Amend'],
      },
      {
        id: 'defects',
        title: 'Defects',
        summary:
          'Report defects against vehicles and equipment, prioritise, assign, and track them through to completion, and configure who is alerted about new defects.',
        component: Defects,
        tags: [
          'Defects',
          'Report Defect',
          'IPC',
          'Priority',
          'Kanban',
          'Defect Alerts',
        ],
      },
    ],
  },
  {
    id: 'cleaning-and-readiness',
    title: 'Cleaning and Readiness',
    pages: [
      {
        id: 'cleaning-schedules',
        title: 'Cleaning Schedules',
        summary:
          'Track deep clean due dates and record interim, deep, and decontamination cleans with ATP testing.',
        component: CleaningSchedules,
        tags: ['Cleaning', 'Deep Clean', 'ATP Testing', 'Decontamination'],
      },
      {
        id: 'make-ready-and-maintenance',
        title: 'Make Ready and Maintenance',
        summary:
          'Check vehicles and assets against configured load lists, run the Restock Queue (with claims) and Start of Shift flows, review per-vehicle and fleet-wide History with trends, and track asset maintenance history.',
        component: MakeReadyAndMaintenance,
        tags: [
          'Make Ready',
          'Maintenance',
          'Load List',
          'Restock Queue',
          'Start of Shift',
          'History',
          'Trends',
          'Audit Trail',
          'Asset Replacement',
        ],
      },
      {
        id: 'load-lists',
        title: 'Load Lists',
        summary:
          'Build and clone the load lists Make Ready checks against, and assign them to vehicles and assets from the editor.',
        component: LoadLists,
        tags: [
          'Load List',
          'Make Ready',
          'Setup Wizard',
          'Configuration',
          'Assignment',
        ],
      },
    ],
  },
]
